import { AfterViewChecked, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { SignaturePad, Point, PointGroup } from 'angular2-signaturepad';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { InputDrawLicense } from './input-draw-license';

@Component({
  selector: 'app-modal-content-draw-license',
  templateUrl: './modal-content-draw-license.component.html',
  styleUrls: ['./modal-content-draw-license.component.scss']
})
export class ModalContentDrawLicenseComponent extends InputDrawLicense implements AfterViewChecked {

  @ViewChild('signatureBody') signatureBody: ElementRef;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  isSetScale = false;
  private autoSize = false;
  private signaturePadOptions: Object = {
    'canvasWidth': 400,
    'canvasHeight': 300,
    'backgroundColor': 'rgba(255,255,255,1)'
  };

  get signatureIsEmpty() {
    return this.signaturePad ? this.signaturePad.isEmpty() : true;
  }

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) { super();   }

  ngAfterViewChecked(): void {
    if (this.signatureBody.nativeElement.offsetWidth > 0 && this.signatureBody.nativeElement.offsetHeight > 0 && !this.isSetScale) {
      setTimeout(() => {
        this.isSetScale = true;
        if (this.autoSize) {
          this.signaturePadOptions['canvasWidth'] = this.signatureBody.nativeElement.clientWidth;
          this.signaturePadOptions['canvasHeight'] = this.signatureBody.nativeElement.clientHeight;
        }
        if (this.signaturePad && this.data) {
          this.signaturePad.fromData(this.data);

        }
      });
    }
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    // Log.debug(this.signaturePad.toDataURL());
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    // Log.debug('begin drawing');
  }

  btnClose() {
    this.hide('close');
  }

  btnOk() {
    if (!this.signatureIsEmpty) {
      // '' save image as PNG
      // 'image/jpeg' save image as JPEG
      // 'image/svg+xml' save image as SVG
      this.dataURL = this.signaturePad.toDataURL(this.imageType);
      this.data = this.signaturePad.toData();
      this.hide('ok');
    }
  }

  private hide(msg: string) {
    this.modalService.onHide.emit(msg);
    this.bsModalRef.hide();
  }

  @HostListener('window:resize', ['$event'])
  handleResize(event) {
    this.hide('resize');
    this.signaturePad.clear();
  }
}
